module.exports = __webpack_public_path__ + "OpenSans-Bold.7ae9b8ba7886341831bf.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Bold/OpenSans-Bold.eot
// module id = ../../../../npm-font-open-sans/fonts/Bold/OpenSans-Bold.eot
// module chunks = styles